import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const CalendarTimeIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92712 12.9602C4.92712 12.4504 5.34039 12.0371 5.8502 12.0371L25.1713 12.0371C25.6811 12.0371 26.0944 12.4504 26.0944 12.9602C26.0944 13.47 25.6811 13.8833 25.1713 13.8833L5.8502 13.8833C5.34039 13.8833 4.92712 13.47 4.92712 12.9602Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8535 4.08301C20.3633 4.08301 20.7766 4.49629 20.7766 5.00608L20.7766 8.54121C20.7766 9.05101 20.3633 9.46429 19.8535 9.46429C19.3437 9.46429 18.9304 9.05101 18.9304 8.54121L18.9304 5.00608C18.9304 4.49629 19.3437 4.08301 19.8535 4.08301Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1736 4.08301C11.6834 4.08301 12.0966 4.49629 12.0966 5.00608L12.0966 8.54121C12.0966 9.05101 11.6834 9.46429 11.1736 9.46429C10.6638 9.46429 10.2505 9.05101 10.2505 8.54121L10.2505 5.00608C10.2505 4.49629 10.6638 4.08301 11.1736 4.08301Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58431 7.3161C7.68785 6.26694 9.22231 5.7793 10.9664 5.7793L20.0617 5.7793C21.8092 5.7793 23.3444 6.26658 24.446 7.31701C25.5546 8.37393 26.1044 9.88666 26.0994 11.6912L26.0994 15.3006C26.0994 15.8105 25.6862 16.2237 25.1764 16.2237C24.6665 16.2237 24.2533 15.8105 24.2533 15.3006L24.2533 11.6901L24.2533 11.6874C24.2575 10.2629 23.832 9.28234 23.1721 8.65316C22.505 8.01716 21.478 7.62545 20.0617 7.62545L10.9664 7.62545C9.55493 7.62545 8.52667 8.0168 7.85636 8.65408C7.19316 9.28459 6.764 10.2663 6.764 11.6901L6.764 21.4118C6.764 22.8649 7.19596 23.8719 7.86279 24.5182C8.53419 25.169 9.56048 25.5673 10.9664 25.5673L13.6129 25.5673C14.1227 25.5673 14.536 25.9806 14.536 26.4904C14.536 27.0002 14.1227 27.4135 13.6129 27.4135L10.9664 27.4135C9.21676 27.4135 7.68032 26.9124 6.57788 25.8439C5.47086 24.7709 4.91785 23.2385 4.91785 21.4118L4.91785 11.6901C4.91785 9.88413 5.47366 8.37201 6.58431 7.3161Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4722 18.5756C19.3573 18.5756 17.6423 20.2912 17.6423 22.4068C17.6423 24.522 19.357 26.2367 21.4722 26.2367C23.5888 26.2367 25.3033 24.5219 25.3033 22.4068C25.3033 20.2915 23.5884 18.5756 21.4722 18.5756ZM15.7961 22.4068C15.7961 19.2723 18.3371 16.7295 21.4722 16.7295C24.6083 16.7295 27.1495 19.2721 27.1495 22.4068C27.1495 25.5417 24.6081 28.0828 21.4722 28.0828C18.3374 28.0828 15.7961 25.5416 15.7961 22.4068Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4464 19.8896C21.9562 19.8896 22.3695 20.3029 22.3695 20.8127L22.3695 22.2206L23.4228 22.8501C23.8604 23.1117 24.0032 23.6783 23.7417 24.116C23.4801 24.5536 22.9133 24.6963 22.4758 24.4349L20.9729 23.5367C20.694 23.37 20.5233 23.0691 20.5233 22.7443L20.5233 20.8127C20.5233 20.3029 20.9366 19.8896 21.4464 19.8896Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.78174 17.2356C9.78174 16.7258 10.195 16.3125 10.7048 16.3125C11.2146 16.3125 11.6287 16.7258 11.6287 17.2356C11.6287 17.7454 11.2154 18.1587 10.7056 18.1587C10.1958 18.1587 9.78174 17.7454 9.78174 17.2356Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3082 17.2356C14.3082 16.7258 14.7215 16.3125 15.2313 16.3125C15.7411 16.3125 16.1551 16.7258 16.1551 17.2356C16.1551 17.7454 15.7418 18.1587 15.232 18.1587C14.7223 18.1587 14.3082 17.7454 14.3082 17.2356Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.78174 21.4084C9.78174 20.8986 10.195 20.4854 10.7048 20.4854C11.2146 20.4854 11.6287 20.8986 11.6287 21.4084C11.6287 21.9183 11.2154 22.3315 10.7056 22.3315C10.1958 22.3315 9.78174 21.9183 9.78174 21.4084Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default CalendarTimeIcon;
